export enum Constants {
  SELECT_SAMPLE_ITEM = '@@sample/SELECT_SAMPLE_ITEM',
  DELETE_SAMPLE_ITEM = '@@sample/DELETE_SAMPLE_ITEM',
  ADD_SAMPLE_ITEM = '@@sample/ADD_SAMPLE_ITEM',
}
